// Endereço na ordem americana (INTERNACIONALIZACAO_EUA_PLAN.md §4.6): "número rua, cidade, ESTADO ZIP".
// As lojas do Brasil continuam montando o endereço do jeito de sempre, em cada tela.

export const linhaEnderecoEua = endereco => {
    const rua = [endereco?.numero, endereco?.rua].filter(Boolean).join(' ');
    const estadoZip = [String(endereco?.uf || '').toUpperCase(), endereco?.cep].filter(Boolean).join(' ');

    return [rua, endereco?.municipio, estadoZip].filter(Boolean).join(', ');
};
